<!-- @format -->

<company-info-complete>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">登録情報変更の完了</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">
            <a onclick="{ props.onFirst }">会社情報</a>
          </li>
          <li class="breadcrumb-item">
            <a onclick="{ props.onForm }">登録情報変更手続き</a>
          </li>
          <li class="breadcrumb-item">登録情報変更の完了</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="contents_block detail">
        <p class="align-c">
          会社情報の登録情報変更の申請が完了しました。
          <br />
          入力された変更内容を確認いたしますので、しばらくお待ちください。
        </p>
        <p class="notice">
          ※変更内容が反映された場合、または内容に確認事項がある場合は「管理者」の権限に設定されているメールアドレスに通知が届きます。
        </p>
        <p class="notice">
          ※今回の変更内容が反映される前でもサービスは引き続きご利用いただけます。
        </p>
        <p class="notice">
          ※同意いただいている「利用規約」に反する内容が確認され場合は、ご利用を停止させていただくことがございます。
        </p>

        <ul class="link_list">
          <li class="link_list-item">
            <a href="{ routes.makePath('top-tag') }">ホームに戻る</a>
          </li>
        </ul>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import routes from "@model/menu-routes.js";

    export default {
      onBeforeMount() {
        this.routes = routes;
      },
      back(e) {
        this.props.fetchApplyingData();
      },
    };
  </script>
</company-info-complete>
